export const autoTopupIdField = 'autoTopupId';

export const selectListColumns = [
  {
    label: 'rechargingtransactions.overview_transaction_id_column_heading',
    tooltip: 'rechargingtransactions.overview_transaction_id_tooltip',
    field: 'transactionId',
    type: 'number',
    filterable: true,
    sortable: true,
    placeholder: ' ',
    agentOnly: true,
  },
  {
    label: 'rechargingtransactions.overview_top_up_time_column_heading',
    tooltip: 'rechargingtransactions.overview_top_up_time_tooltip',
    field: 'topUpTime',
    filterable: true,
    sortable: true,
    placeholder: ' ',
    type: 'string',
  },
  {
    label: 'rechargingtransactions.overview_top_up_method_column_heading',
    tooltip: 'rechargingtransactions.overview_top_up_method_tooltip',
    field: 'rechargingMethod',
    type: 'string',
    filterable: true,
    sortable: true,
    placeholder: ' ',
  },
  {
    label: 'rechargingtransactions.overview_top_up_amount_column_heading',
    tooltip: 'rechargingtransactions.overview_top_up_amount_tooltip',
    field: 'amount',
    filterable: true,
    sortable: true,
    placeholder: ' ',
    type: 'number',
  },
  {
    label: 'rechargingtransactions.overview_voucher_serial_number_column_heading',
    tooltip: 'rechargingtransactions.overview_voucher_serial_number_tooltip',
    field: 'serialNumber',
    type: 'string',
    filterable: true,
    sortable: true,
    placeholder: ' ',
  },
  {
    label: 'rechargingtransactions.overview_state_column_heading',
    tooltip: 'rechargingtransactions.overview_state_tooltip',
    field: 'transactionStateId',
    filterable: true,
    sortable: true,
    placeholder: ' ',
    agentOnly: true,
  },
  {
    label: 'rechargingtransactions.overview_auto_top_up_id_column_heading',
    tooltip: 'rechargingtransactions.overview_auto_top_up_id_tooltip',
    field: autoTopupIdField,
    filterable: true,
    sortable: true,
    placeholder: ' ',
    agentOnly: true,
  },
  {
    label: 'rechargingtransactions.overview_action_column_heading',
    tooltip: '',
    filterable: false,
    sortable: false,
    placeholder: ' ',
    agentOnly: true,
    action: true,
  },
];

export default selectListColumns;
